import { Link } from '@tanstack/react-router'
import { ArrowRight, BadgeCheck } from 'lucide-react'

import { useWebContent } from '../../hooks/useWebContent'
import { richTextListClassName } from '../../utils/richText'

export const HeroSection = () => {
    const { getText } = useWebContent('HERO')

    return (
        <section className="relative flex min-h-[80vh] w-full items-center overflow-hidden bg-off-white">
            <div className="absolute inset-0 z-0">
                <div className="absolute inset-0 z-10 bg-gradient-to-r from-off-white via-off-white/80 to-transparent" />
                <div
                    className="absolute inset-0 bg-cover bg-center opacity-20 grayscale"
                    style={{
                        backgroundImage:
                            'url("https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1920&q=80")',
                    }}
                />
            </div>
            <div className="relative z-20 mx-auto w-full max-w-[1280px] px-6 py-20">
                <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-brand-yellow/30 bg-brand-yellow/20 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-brand-dark">
                    <BadgeCheck className="h-4 w-4 text-primary" />
                    {getText('badge')}
                </div>
                <h1 className="mb-8 max-w-3xl text-5xl font-bold leading-[1.15] text-brand-dark md:text-7xl">
                    {getText('heading')}
                    <br />
                    <span className="text-primary">{getText('headingHighlight')}</span>
                </h1>
                <div
                    dangerouslySetInnerHTML={{ __html: getText('description') }}
                    className={`mb-12 max-w-2xl text-lg leading-relaxed text-brand-gray md:text-xl ${richTextListClassName}`}
                />
                <div className="flex w-full flex-col gap-5 sm:w-auto sm:flex-row">
                    <Link
                        to="/lifestyle-programs"
                        className="flex items-center justify-center gap-3 rounded-full bg-primary px-10 py-4 text-lg font-bold text-white shadow-xl shadow-primary/20 transition-all hover:bg-primary/90"
                    >
                        {getText('ctaPrimary')}
                        <ArrowRight className="h-5 w-5" />
                    </Link>
                    <Link
                        to="/events"
                        className="flex items-center justify-center gap-3 rounded-full border-2 border-brand-yellow bg-white px-10 py-4 text-lg font-bold text-brand-dark transition-all hover:bg-brand-yellow/10"
                    >
                        {getText('ctaSecondary')}
                    </Link>
                </div>
            </div>
            <div className="absolute bottom-0 right-0 hidden h-full w-1/3 lg:block">
                <div className="h-full w-full bg-gradient-to-l from-primary/5 to-transparent" />
            </div>
        </section>
    )
}
